<script>
  import { _ } from 'svelte-i18n'
  import { logInUser } from '../../services/user'
  import { modals } from '../../stores'
  import { onMount } from 'svelte'
  import queryString from 'query-string'
  import Fieldset from '../../elements/Fieldset.svelte'
  import Label from '../../elements/Label.svelte'
  import Input from '../../elements/Input.svelte'
  import Button from '../../elements/Button.svelte'
  import FormError from '../../elements/FormError.svelte'
  import Modal from '../../elements/Modal.svelte'

  let modal_id = 'login'
  let button_busy = false
  let form_element
  let show_login_error = false
  let login_error_to_show = 0;
  let login_email = ""

  onMount(() => {
    let qs = queryString.parse(window.location.search)
    if (qs.login_email) {
      login_email = qs.login_email
      modals.open('login')
    }
	})

  async function handleSubmit(event) {
    button_busy = true
    show_login_error = false

    let form_data = new FormData()
    form_data.append('email', event.target.email.value)
    form_data.append('password', event.target.password.value)

    logInUser(form_data)
    .then(response => {
      button_busy = false
      if (response === false) {
        show_login_error = true
        login_error_to_show ++
      }
      else closeModal()
    })
    .catch(e => console.error(e))
  }

  function closeModal() {
    // reset modal state
    login_email = ""
    show_login_error = false
    login_error_to_show = 0
    button_busy = false
    console.log('ModalLogin - Closing modal')
    modals.close('login')
  }

</script>

<Modal id={modal_id} on:modalClosed={closeModal}>
  <span slot="header">
    {$_('modals.login.title')}
  </span>
  <span slot="content">
    <FormError bind:visible={show_login_error}>
      {@html $_('modals.login.loginError'+login_error_to_show % 3)}
    </FormError>
    <form bind:this={form_element} on:submit|preventDefault="{handleSubmit}">
      <Fieldset>
        <Label name="email" >{$_('forms.emailAddress')}</Label>
        <Input type="email" name="email" autocomplete="username" focused=true bind:value={login_email}/>
      </Fieldset>
      <Fieldset>
        <Label name="password">{$_('forms.password')}</Label>
        <Input type="password" name="password" autocomplete="current-password"/>
      </Fieldset>
      <Button kind="accent" type="submit" busy={button_busy}>{$_('buttons.login')}</Button>
      <div class="forgot-wrapper">
        <Button kind="transparent" on:click={() => modals.open('forgotPassword')}>{$_('buttons.forgotPassword')}</Button>
      </div>
    </form>
  </span>
  <span slot="footer">
  </span>
  <span slot="banner">
    {$_('modals.login.dontHave')}<br>
    <!-- svelte-ignore a11y-invalid-attribute -->
    <a href="#" on:click|preventDefault={() => modals.open('buy')}>{$_('modals.login.buyLink')}</a> 
    {$_('modals.login.buyLinkDescription')}
  </span>
</Modal>

<style>
  .forgot-wrapper {
    float: right;
  }
  a {
    color: var(--c-text-on-fill);
  }
  a:hover {
    color: var(--c-text-on-fill-hover);
  }
</style>